import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { HiOutlineMenuAlt2 } from "react-icons/hi";

const MENU_ITEMS = [
  { key: "fnf", name: "F&F Milkyway", path: "/" },
  { key: "fnco", name: "F&CO Milkyway", path: "/fnco-download" },
  { key: "cn", name: "CN Milkyway", path: "/CNdownload" },
];

const MilkyWayMenu = ({ currentCompany }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const menuRef = useRef(null);
  const navigate = useNavigate();

  const currentItem =
    MENU_ITEMS.find((item) => item.key === currentCompany) || MENU_ITEMS[0];

  // 메뉴 외부 클릭 시 닫기
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsMenuOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleMenuSelect = (path) => {
    setIsMenuOpen(false);
    navigate(path);
  };

  return (
    <div
      ref={menuRef}
      style={{
        position: "fixed",
        top: "20px",
        left: "20px",
        zIndex: 1000,
      }}
    >
      <button
        onClick={() => setIsMenuOpen(!isMenuOpen)}
        style={{
          background: "white",
          border: "1px solid #e0e0e0",
          borderRadius: "8px",
          cursor: "pointer",
          padding: "10px 14px",
          display: "flex",
          alignItems: "center",
          gap: "8px",
          fontSize: "14px",
          color: "#333",
          boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
        }}
      >
        <HiOutlineMenuAlt2 size={20} />
        <span style={{ fontWeight: "500" }}>{currentItem.name}</span>
      </button>

      {/* 드롭다운 메뉴 */}
      {isMenuOpen && (
        <div
          style={{
            position: "absolute",
            top: "100%",
            left: 0,
            marginTop: "4px",
            backgroundColor: "white",
            boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
            borderRadius: "8px",
            overflow: "hidden",
            minWidth: "180px",
          }}
        >
          {MENU_ITEMS.map((item) => (
            <button
              key={item.key}
              onClick={() => handleMenuSelect(item.path)}
              style={{
                width: "100%",
                padding: "12px 16px",
                border: "none",
                background: currentCompany === item.key ? "#f0f0f0" : "white",
                cursor: "pointer",
                textAlign: "left",
                fontSize: "14px",
                fontWeight: currentCompany === item.key ? "600" : "400",
                display: "flex",
                alignItems: "center",
                gap: "8px",
              }}
              onMouseOver={(e) => (e.target.style.backgroundColor = "#f5f5f5")}
              onMouseOut={(e) =>
                (e.target.style.backgroundColor =
                  currentCompany === item.key ? "#f0f0f0" : "white")
              }
            >
              {currentCompany === item.key && "✓"} {item.name}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default MilkyWayMenu;

